import EditTaskService from "./rpc/EditTaskService";
import ProjectInfoService from "./rpc/ProjectInfoService";
import CustomerInfoService from "./rpc/CustomerInfoService";

class TaskActionsProvider {
    constructor(editTaskService) {
        this.editTaskService = editTaskService;
    }

    getAssignedUsers(taskId) {
        return this.editTaskService.getAssignedUsers(taskId).catch(this._commonErrorsHandler)
    }

    updateAssignedUsers(taskId, addedUserIds, removeUserIds) {
        return this.editTaskService.updateAssignedUsers(taskId, addedUserIds, removeUserIds).catch(this._commonErrorsHandler)
    }

    updateManagers(taskId, addedUserIds, removeUserIds) {
        return this.editTaskService.updateManagers(taskId, addedUserIds, removeUserIds).catch(this._commonErrorsHandler)
    }

    _commonErrorsHandler(e) {
        throw e
    }
}

class ProjectActionsProvider {
    constructor(projectInfoService) {
        this.projectInfoService = projectInfoService;
    }

    getAssignedUsers(projectId) {
        return this.projectInfoService.getAssignedUsers(projectId).catch(this._commonErrorsHandler)
    }

    updateAssignedUsers(projectId, addedUserIds, removeUserIds) {
        return this.projectInfoService.updateAssignedUsers(projectId, addedUserIds, removeUserIds).catch(this._commonErrorsHandler)
    }

    updateManagers(projectId, addedUserIds, removeUserIds) {
        return this.projectInfoService.updateManagers(projectId, addedUserIds, removeUserIds).catch(this._commonErrorsHandler)
    }

    _commonErrorsHandler(e) {
        throw e
    }
}

class CustomerActionsProvider {
    constructor(customerInfoService) {
        this.customerInfoService = customerInfoService;
    }

    getAssignedUsers(customerId) {
        return this.customerInfoService.getAssignedUsers(customerId).catch(this._commonErrorsHandler)
    }

    updateAssignedUsers(customerId, addedUserIds, removeUserIds) {
        return this.customerInfoService.updateAssignedUsers(customerId, addedUserIds, removeUserIds).catch(this._commonErrorsHandler)
    }

    getManagers(customerId) {
        return this.customerInfoService.getManagers(customerId).catch(this._commonErrorsHandler)
    }

    updateManagers(customerId, addedUserIds, removeUserIds) {
        return this.customerInfoService.updateManagers(customerId, addedUserIds, removeUserIds).catch(this._commonErrorsHandler)
    }

    getAssignedUsersForAll() {
        return this.customerInfoService.getAssignedUsersForAll().catch(this._commonErrorsHandler)
    }

    getManagersForAll() {
        return this.customerInfoService.getManagersForAll().catch(this._commonErrorsHandler)
    }

    _commonErrorsHandler(e) {
        throw e
    }
}

export const taskActionsProvider = new TaskActionsProvider(new EditTaskService());
export const projectActionsProvider = new ProjectActionsProvider(new ProjectInfoService());
export const customerActionsProvider = new CustomerActionsProvider(new CustomerInfoService());


// WEBPACK FOOTER //
// ./web/js/panels/actionsProviders.js